<script setup>
defineProps({
  loading: Boolean,
  text: {
    type: String,
    default: 'lorem ipsum dolor'

  }
})
</script>

<template>
  <span :class="{'tw-animate-pulse tw-text-transparent tw-bg-gray-100 tw-rounded-lg': loading }">
    <slot>{{ text }}</slot>
  </span>
</template>